<template>
  <div>
    <label for="info-modal">
      <slot></slot>
    </label>

    <input type="checkbox" id="info-modal" class="modal-toggle" />
    <div class="modal">
      <div
        class="transition-all modal-box max-w-[60%]"
        :class="{ 'max-w-[80%] ': demo }"
      >
        <div v-if="!demo" class="flex">
          <div class="self-center w-5/12 text-lg text-center">
            <h1 class="text-4xl font-bold text-center">
              {{
                info?.name ||
                  "Hey Dev, Pense à remplir le titre (info.name) pour cette boite d'aide "
              }}
            </h1>
            <div class="flex justify-center mt-4">
              <div
                class="flex items-center justify-center w-16 h-16 rounded-full bg-primary animate-bounce"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="w-12 h-12 text-white"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </div>
            </div>
            <p class="mt-4 tracking-wide">
              {{
                info?.description ||
                  "Hey Dev, Pense à remplir la description (info.description) pour cette boite d'aide "
              }}
            </p>
          </div>

          <div class="flex-1">
            <ol
              class="flex flex-col justify-center w-10/12 h-full pl-8 mx-auto list-decimal "
            >
              <h1
                class="mb-4 text-4xl font-bold text-center logo-font text-primary"
              >
                Demarche du module
              </h1>
              <li
                class=""
                :class="{
                  'font-bold text-primary text-lg': currentStep == index + 1
                }"
                v-for="(item, index) in currentModule.moduleDemarche"
                :key="index"
              >
                {{ item.title ?? item }}
                <ul v-if="item.subs">
                  <li
                    class="ml-8 list-disc"
                    v-for="(sub, index) in item.subs"
                    :key="index"
                  >
                    {{ sub }}
                  </li>
                </ul>
              </li>
            </ol>
          </div>
        </div>

        <div v-else>
          <h1 class="text-4xl font-bold text-center">Démonstration</h1>

          <div
            class="
              w-full
              h-[60vh]
              mt-4
              overflow-hidden
              relative
              flex
              justify-center
              items-center
            "
          >
            <button
              v-if="!demolink && !youtube"
              @click="demolink = link"
              class="absolute flex items-center justify-center w-12 h-12 rounded-full bg-primary btn btn-square btn-circle"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="w-8 h-8 text-white"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z"
                  clip-rule="evenodd"
                />
              </svg>
            </button>
            <iframe
              v-if="youtube"
              class="w-full h-full"
              :src="youtube"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
            <img
              v-if="!youtube"
              class="object-contain w-full h-full"
              :src="
                demolink ||
                  'https://images.unsplash.com/photo-1633113089635-115b38c66c49?ixlib=rb-1.2.1&ixid=MnwxMjA3fDF8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80'
              "
              alt=""
            />
          </div>
        </div>

        <div class="modal-action">
          <button
            v-show="(link || youtube) && !demo"
            @click="demo = true"
            for="show-demo-modal"
            class="normal-case btn btn-secondary"
          >
            Voir la demo
          </button>
          <button v-if="demolink" class="normal-case btn btn-secondary">
            Rejouer
          </button>
          <label
            for="info-modal"
            @click="
              demo = false;
              demolink = '';
            "
            class="normal-case btn btn-primary"
            >Fermer</label
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HelpModal",
  props: {
    link: String,
    youtube: String,
    currentStep: Number,
    info: Object
  },
  data() {
    return {
      demo: false,
      demolink: ""
    };
  },
  computed: {
    currentModule() {
      return this.$store.state.currentModule;
    }
  }
};
</script>

<style></style>
